export default __webpack_public_path__ + "static/media/Icon.58950b25.svg";